export default __webpack_public_path__ + "static/media/apvs-arte-2.c67eb0dc.webp";